import { call, put, select, takeLatest } from "redux-saga/effects";
import { ActionTypes } from "./types";
import { failure, success } from "./actions";
import { snack } from "components/GlobalSnackbar";
import { getError } from "utils";
import { RootState } from "../../../root_reducer";
import { apiRelatorio, cacheDados } from "configs";
import { IListaDiarioClasse } from "@deltasge/marauders-map";

function* request() {
  try {
    const {
      usuario: { usuario },
    }: RootState = yield select();

    if (!usuario) {
      throw new Error("Usuário não encontrado");
    }

    const cache24h = 60 * 24;
    const key = `diario-classe-${usuario?.escolaId}`;
    const cache = cacheDados.get<IListaDiarioClasse[]>(key);
    if (cache && typeof cache != "string") {
      yield put(success(cache));
    } else {
      const { data } = yield call(apiRelatorio.get, "/diario/modelos");
      if (!data || !Array.isArray(data)) {
        throw new Error("Nenhum modelo de diário encontrado");
      }
      yield put(success(data as IListaDiarioClasse[]));
      cacheDados.set(key, data as IListaDiarioClasse[], cache24h);
    }
  } catch (error) {
    yield put(failure());
    snack.error(getError(error));
  }
}
export const sagas = takeLatest([ActionTypes.REQUEST], request);
